import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "field-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_AlbumCollaborators = _resolveComponent("AlbumCollaborators")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        ref: "modal",
        onClose: _ctx.cleanup
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Share Album')), 1)
        ]),
        default: _withCtx(() => [
          (_ctx.showEditFields)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.t('memories', 'Name of the album')), 1),
                _createVNode(_component_NcTextField, {
                  modelValue: _ctx.albumName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.albumName) = $event)),
                  type: "text",
                  name: "name",
                  required: true,
                  autofocus: "true",
                  placeholder: _ctx.t('memories', 'Name of the album')
                }, null, 8, ["modelValue", "placeholder"])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.album)
            ? (_openBlock(), _createBlock(_component_AlbumCollaborators, {
                key: 1,
                ref: "collaborators",
                "album-name": _ctx.album.basename,
                collaborators: _ctx.album.collaborators,
                "public-link": _ctx.album.publicLink,
                "allow-public-link": true
              }, {
                default: _withCtx(({ collaborators }) => [
                  _createVNode(_component_NcButton, {
                    "aria-label": _ctx.t('memories', 'Save collaborators for this album.'),
                    variant: "primary",
                    disabled: _ctx.loadingAddCollaborators,
                    onClick: ($event: any) => (_ctx.save(collaborators))
                  }, {
                    icon: _withCtx(() => [
                      (_ctx.loadingAddCollaborators)
                        ? (_openBlock(), _createBlock(_component_XLoadingIcon, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Save')), 1)
                    ]),
                    _: 1
                  }, 8, ["aria-label", "disabled", "onClick"])
                ]),
                _: 1
              }, 8, ["album-name", "collaborators", "public-link"]))
            : (_openBlock(), _createBlock(_component_XLoadingIcon, {
                key: 2,
                class: "album-share fill-block"
              }))
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}